import { head } from "@omni/utils/array.utils";
import { shallowEqual, useSelector } from "react-redux";

import { getProductsWithCallToActions } from "@/redux/modules/api/data/cart/cart.cta.selectors";
import { CallToActionsProvider } from "@/utils/callToActions/callToActions.provider";

import Action from "./action/action.component";
import Selectable from "./selectable/selectable.component";

const CtaWrapper = () => {
    const callToActionProducts = useSelector(
        getProductsWithCallToActions,
        shallowEqual
    );

    let firstCTAProduct = head(callToActionProducts);
    const noProductCTA = callToActionProducts.find((cta) => !cta.product);
    // Prio on CTA's without products
    if (noProductCTA) {
        firstCTAProduct = noProductCTA;
    }

    const hasSilentAction =
        firstCTAProduct?.actions.some((a) => a.isSilentAction) &&
        !!firstCTAProduct.product;

    return (
        <>
            {firstCTAProduct && (
                <CallToActionsProvider
                    callToActionProducts={callToActionProducts}
                >
                    {hasSilentAction && <Action cta={firstCTAProduct} />}
                    {!hasSilentAction && <Selectable cta={firstCTAProduct} />}
                </CallToActionsProvider>
            )}
        </>
    );
};

export { CtaWrapper };
